import { observer } from "mobx-react-lite";
import { useContext, useEffect, useState } from "react";
import { broadcastSettings } from "../../app/models/broadcast";
import "../../assets/scss/broadcastController/broadcastController.scss";

import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";
import { OpenVidu, Device } from "openvidu-browser";
import { RootStoreContext } from "../../app/stores/rootStore";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

interface Devices {
  audioSources: Device[];
  videoSources: Device[];
}
interface BroadcastSettingsProps {
  toggle: () => void;
  broadcastSettings: broadcastSettings;
  onSettingsChange: (newSettings: broadcastSettings) => void;
}

const BroadcastSettings = ({
  broadcastSettings,
  onSettingsChange,
  toggle,
}: BroadcastSettingsProps) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [settings, setSettings] =
    useState<broadcastSettings>({
      microphoneDevice: undefined,
      cameraDevice: undefined,
      microphoneThreshold: -50,
     });
  const [device, setDevice] = useState<Devices>({
    audioSources: [],
    videoSources: [],
  });
  const [audioDropdownOpen, setAudioDropdownOpen] = useState(false);
  const [videoDropdownOpen, setVideoDropdownOpen] = useState(false);
  const [t] = useTranslation(["translation"], translationHookOptions);

  useEffect(() => {
    // Crea un'istanza di OpenVidu
    const openvidu = new OpenVidu();

    // Ottieni la lista delle sorgenti video disponibili utilizzando OpenVidu
    openvidu.getDevices().then((devices) => {
      const audioSources: Device[] = [];
      const videoSources: Device[] = [];

      devices.forEach((deviceInput) => {
        if (deviceInput.kind === "audioinput") {
          audioSources.push(deviceInput);
        } else if (deviceInput.kind === "videoinput") {
          videoSources.push(deviceInput);
        }
      });

      setDevice({
        audioSources: audioSources,
        videoSources: videoSources,
      });
    });
  }, []);
useEffect(()=> {
  setSettings(broadcastSettings);
},[broadcastSettings])

  const handleSave = () => {
    console.log(settings)
    onSettingsChange(settings);
    toggle();
  };

  const toggleAudioDropdown = () => {
    setAudioDropdownOpen(!audioDropdownOpen);
  };

  const toggleVideoDropdown = () => {
    setVideoDropdownOpen( !videoDropdownOpen);
  };

  const handleDeviceSelect = (isAudio: boolean, selectedDevice: Device) => {
    console.log("internalSettings")
    let deviceObj : broadcastSettings = {
      microphoneDevice: undefined,
      cameraDevice: undefined,
      microphoneThreshold: -50,
     };
    if (isAudio) {
      deviceObj.microphoneDevice = selectedDevice;
      deviceObj.cameraDevice = settings.cameraDevice;
      toggleAudioDropdown();
    }
    else {
      deviceObj.cameraDevice = selectedDevice;
      deviceObj.microphoneDevice = settings.microphoneDevice;
      toggleVideoDropdown();
    }
    deviceObj.microphoneThreshold = settings.microphoneThreshold;
    setSettings(deviceObj);
  };

  return (
    <div>
      <Row className={"broadcastSettingRow"}>
        <Dropdown isOpen={audioDropdownOpen} toggle={toggleAudioDropdown}>
          <DropdownToggle caret style={{backgroundColor: "transparent !important"}}>
            {settings.microphoneDevice
              ? settings.microphoneDevice.label
              : t("SelectAudioDevice")}
          </DropdownToggle>
          <DropdownMenu>
            {device.audioSources.map((device) => (
              <DropdownItem key={device.deviceId} name="microphoneDevice">
                <div onClick={() => handleDeviceSelect(true, device)}>
                  <span className={"audioDeviceItem"}></span>
                  {device.label}
                </div>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </Row>
      <Row className={"broadcastSettingRow"}>
        <Dropdown isOpen={videoDropdownOpen} toggle={toggleVideoDropdown}>
          <DropdownToggle caret>
            {settings.cameraDevice
              ? settings.cameraDevice.label
              : t("SelectVideoDevice")}
          </DropdownToggle>
          <DropdownMenu>
            {device.videoSources.map((device) => (
              <DropdownItem key={device.deviceId} name="cameraDevice">
                <div onClick={() => handleDeviceSelect(false, device)}>
                  <span className={"videoDeviceItem"}></span>
                  {device.label}
                </div>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </Row>
      {/* <Row className={"broadcastSettingRow"}>
        <label>
          Microphone Threshold:
          <input
            type="range"
            name="microphoneThreshold"
            min="-50"
            max="-10"
            step="0.5"
            value={settings.microphoneThreshold}
            onChange={handleInputChange}
          />
          {settings.microphoneThreshold}
        </label>
      </Row> */}
      <Row className="saveSettingsRow">
        <Button className={`btn-sm ${theme?.buttonSecondaryColor} ${theme?.buttonSecondaryBorderColor}`} onClick={handleSave}>{t("Save")}</Button>
      </Row>
    </div>
  );
};

export default observer(BroadcastSettings);
